import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
    width: ({ isFullWidth, provider }) => (isFullWidth || provider ? '100%' : 450),
    maxWidth: '100%',
    paddingBottom: 10,
    overflowX: 'hidden',
    overflowY: 'auto',
    [theme.breakpoints.down('xs')]: {
      width: theme.breakpoints.values.sm,
    },
    maxHeight: ({ maxHeight }) => maxHeight,
  },
}));

const QuestionOptionsContainer = ({ isFullWidth, maxHeight, children }) => {
  const { appConfiguration: { providerSpecific } = {} } = useSelector((state) => state) ?? {};
  const classes = useStyles({ isFullWidth, maxHeight, provider: providerSpecific?.code });

  return <Box className={classes.root}>{children}</Box>;
};

QuestionOptionsContainer.propTypes = {
  isFullWidth: PropTypes.bool,
  maxHeight: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default QuestionOptionsContainer;
